export default "__VITE_ASSET__D24h$zHY__"